import { ReactNode } from "react";

import {
  Box,
  Button,
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
  Flex as ChakraFlex,
  FlexProps as ChakraFlexProps,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";

import { ChevronLeftIcon } from "@chakra-ui/icons";

interface ButtonProps extends ChakraButtonProps {
  children: string;
  color: string;
  size?: string;
  LIcon?: string;
  RIcon?: string;
}
interface PropsBtn extends ChakraButtonProps {
  width?: string | string[];
  href?: string;
  color?: string;
  Fsize?: string;
  weightCustom?: string;
  params?: any;
}
interface StyledButtonProps extends ChakraFlexProps {
  children: ReactNode;
}

export function PrimaryButton({ children, color, size, LIcon, RIcon, ...rest }: ButtonProps) {
  return (
    <Box>
      <ChakraButton borderRadius={0} colorScheme={color} variant="solid" {...rest}>
        {children}
      </ChakraButton>
    </Box>
  );
}

export function OutlinedButton({ children, color, RIcon, LIcon, size, ...rest }: ButtonProps) {
  return (
    <Box w={200} h={40}>
      <ChakraButton size={size} borderRadius={0} colorScheme={color} variant="outlined" {...rest}>
        {children}
      </ChakraButton>
    </Box>
  );
}
export function BtnTable({ children, href, ...rest }: PropsBtn) {
  return (
    <Button
      {...rest}
      variant={"primary-button"}
      bgColor={"ll-blue.main"}
      as="a"
      href={href}
      width="150px"
      _hover={{ opacity: "0.5" }}
    >
      {children}
    </Button>
  );
}

export function BtnDefault({ Fsize, color, width, children, weightCustom, ...rest }: PropsBtn) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <ChakraButton
      {...rest}
      fontSize={Fsize ? Fsize : isWideVersion ? "14px" : "12px"}
      textStyle="MRegular"
      color={color ? color : "white"}
      fontWeight={weightCustom ? weightCustom : "medium"}
      borderRadius="5px"
      p={"1.5rem"}
      width={width ? width : isWideVersion ? "250px" : "100%"}
    >
      {children}
    </ChakraButton>
  );
}

export function BtnBackSidebar({ ...rest }: ChakraFlexProps) {
  return (
    <ChakraFlex m="-15px 0 20px -10%">
      <ChakraFlex {...rest} as="button" alignItems="center" width="100%">
        <ChevronLeftIcon p="20x" fontSize="40px" backgroundColor="gray.300" mr="10px" />

        <Text display="flex" fontSize="12px" textTransform="uppercase" as="span">
          voltar
        </Text>
      </ChakraFlex>
    </ChakraFlex>
  );
}

export function StyledButton({ children, ...rest }: StyledButtonProps) {
  return (
    <ChakraFlex
      as="label"
      flex="1"
      paddingY="4"
      paddingX="8"
      marginLeft="6"
      alignSelf="center"
      alignItems="center"
      position="relative"
      justify="center"
      transform="skew(-20deg)"
      _hover={{ opacity: "0.9" }}
      _focus={{ boxShadow: "none" }}
      {...rest}
      cursor="pointer"
    >
      {children}
    </ChakraFlex>
  );
}
